<template>
  <div>
    <div class="search">
      <el-form
        size="small"
        :inline="true"
        :model="listQuery"
        class="demo-form-inline"
      >
        <el-form-item>
          <el-select
            class="form-input"
            clearable
            v-model="listQuery.department_id"
            :placeholder="$t('contactUs.recruitmentTable.chooseDepartment')"
          >
            <el-option
              v-for="item in department"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            class="form-input"
            clearable
            v-model="listQuery.job_type_id"
            :placeholder="$t('contactUs.recruitmentTable.chooseCategory')"
          >
            <el-option
              v-for="item in job_type"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            class="form-input"
            clearable
            v-model="listQuery.work_place_id"
            :placeholder="$t('contactUs.recruitmentTable.chooseLocation')"
          >
            <el-option
              v-for="item in work_place"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            class="form-input"
            :placeholder="$t('contactUs.recruitmentTable.choosePosition')"
            v-model="listQuery.name"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            round
            style="background-color: rgba(50, 88, 159, 1); color: #ffffff"
            @click="(listQuery.page = 1), load()"
            >{{$t('home.searchBtn')}}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="menuBox hidden-xs-only">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        highlight-current-row
        @row-click="rowClick"
        :header-cell-style="{
          background: '#f2f2f2',
          color: '#909399',
        }"
      >
        <el-table-column
          prop="name"
          :label="$t('contactUs.recruitmentTable.jobTitle')"
          min-width="150"
        />
        <el-table-column
          prop="department_name"
          :label="$t('contactUs.recruitmentTable.department')"
          min-width="140"
        />
        <el-table-column
          prop="job_type_name"
          :label="$t('contactUs.recruitmentTable.recruitmentCategory')"
          min-width="150"
        />
        <el-table-column
          prop="work_place_name"
          :label="$t('contactUs.recruitmentTable.workingLocation')"
          min-width="150"
        />
        <el-table-column
          prop="add_time"
          :label="$t('contactUs.recruitmentTable.releaseTime')"
          width="130"
        />
      </el-table>
    </div>

    <div class="hidden-sm-and-up">
      <el-card
        v-for="item in tableData"
        :body-style="{ padding: '15px' }"
        class="card"
      >
        <div @click="rowClick(item)">
          <div class="date">
            {{ $t("contactUs.recruitmentTable.releaseTime") }}：{{
              item.add_time
            }}
          </div>
          <div class="card-content">
            <div>
              {{ $t("contactUs.recruitmentTable.jobTitle") }}：{{ item.name }}
            </div>
            <div>
              {{ $t("contactUs.recruitmentTable.department") }}：{{
                item.department_name
              }}
            </div>
            <div>
              {{ $t("contactUs.recruitmentTable.recruitmentCategory") }}：{{
                item.job_type_name
              }}
            </div>
            <div>
              {{ $t("contactUs.recruitmentTable.workingLocation") }}：{{
                item.work_place_name
              }}
            </div>
            <!-- <div>描述：{{ item.remark }}</div> -->
          </div>
        </div>
      </el-card>
    </div>
    <div class="pagination">
      <el-pagination
        @current-change="load"
        :current-page.sync="listQuery.page"
        :page-size.sync="listQuery.size"
        layout="total, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { recruitIndex, recruitInit } from "@/api/contactUs";
import { formatTimeNum } from "@/utils/index";
export default {
  data() {
    return {
      listQuery: {
        page: 1,
        size: 10,
      },
      loading: false,
      totalNum: 0,
      tableData: [],
      department: [],
      job_type: [],
      work_place: [],
    };
  },
  created() {
    this.init();
    this.load();
  },
  methods: {
    load() {
      recruitIndex(this.listQuery)
        .then((res) => {
          if (res.code === 0) {
            res.data.data.forEach((Element) => {
              Element.add_time = formatTimeNum(Element.add_time, "Y-M-D");
            });
            this.tableData = res.data.data;
            this.totalNum = res.data.count;
          }
        })
        .catch((err) => {});
    },
    init() {
      recruitInit()
        .then((res) => {
          if (res.code == 0) {
            this.department = res.data.department;
            this.job_type = res.data.job_type;
            this.work_place = res.data.work_place;
          }
        })
        .catch((err) => {});
    },
    rowClick(row, column, event) {
      this.$router.push({
        path: `/ContactUs/talentRecruitment/positionDetails`,
        query: { id: row.id },
      });
    },
  },
};
</script>

<style scoped>
.pagination {
  margin-top: 20px;
  text-align: center;
}
.card {
  margin-bottom: 20px;
}
.date {
  font-size: 13px;
  font-weight: 800;
  padding-bottom: 15px;
  border-bottom: 1px solid #dcdfe6;
}
.form-input {
  width: 150px;
}
.form-input /deep/.el-input__inner {
  border-radius: 50px;
}
/* .card-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
} */
.card-content > div {
  font-size: 13px;
  margin-top: 15px;
}
@media only screen and (max-width: 768px) {
  .form-input {
    width: 150px;
  }
}
</style>